/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './BlankWithDesktopSideBarTemplate.style';

import SideBar from 'src/shared/app/base/component/aside/SideBar';
import MainSwitch from 'src/shared/app/base/component/switch/MainSwitch';

const useStyles = createUseStyles(styles);

const BlankWithDesktopSideBarTemplate = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <SideBar layoutClass={classes.aside} />
      <MainSwitch layoutClass={classes.main} />
    </div>
  );
};

export default compose(React.memo)(BlankWithDesktopSideBarTemplate);
